$(function () {

    $('.footer').replaceWith(function() {
        return $(this); // Replace the source div with itself
    }).appendTo('#customFooter'); // Append the replaced div to the target div

    var headerHeight = $('#customHeader').height();
    $('body').css({ '--custom-header-height': headerHeight + 'px' });
    $('body').css({ '--custom-footer-height': headerHeight + 'px' });
    
    var div1 = $('.s-1').height();
    var div2 = $('.s-2').height();
    var footerHeight = $('#customFooter').height();
    
    var totalViewPortHeight = headerHeight + div1 + div2 + footerHeight;

    $('.hidden-div').css({ 'min-height': totalViewPortHeight + 'px' });
    
    var forDiv2 = div1;
    
    var forFooter = div1 + div2;
    
    $(window).scroll(function () {
      if ($(this).scrollTop() >= forDiv2) {
        console.log('header just passed.');
        $('.s-2').addClass('active');
      } else if ($(this).scrollTop() < forDiv2) {
        $('.s-2').removeClass('active');
      }
      
      if ($(this).scrollTop() >= forFooter) {
        console.log('header just passed.');
        $('#customFooter').addClass('active');
        $('#customHeader').addClass('active');
        $('.s-2').attr('style', 'transform: translateY(-' + div2 + 'px) !important');
      } else if ($(this).scrollTop() < forFooter) {
        $('#customFooter').removeClass('active');
        $('#customHeader').removeClass('active');
        $('.s-2').removeAttr( "style");
      }
    });

    $('.humberger_menu_custom').click(function () {
      $(this).addClass('active');
      $('.hamburger2').addClass('active');
      $('aside').addClass('active');
    });
    $('.hamburger2').click(function () {
      $('.hamburger1').removeClass('active');
      $(this).removeClass('active');
      $('aside').removeClass('active');
    });
    $('aside::before').click(function () {
      $('.hamburger1').removeClass('active');
      $(this).removeClass('active');
      $('aside').removeClass('active');
    });

    $('.sliderCustomParallax').slick({
      centerMode: true,
      slidesToShow: 2,
      arrows: false,
      infinite: true,
      responsive: [
        {
          breakpoint: 760,
          settings: {
            slidesToShow: 1
          }
        },
        {
          breakpoint: 600,
          settings: {
            centerMode: false,
            arrows: true,
            slidesToShow: 1
          }
        }
      ]
    });

    // // Get all the H2 elements with the class brandName
    // const h2Elements = document.querySelectorAll('.brandName');

    // h2Elements.forEach((h2Element) => {
    //     const text = h2Element.textContent.trim(); // Get text content
    //     h2Element.innerHTML = ''; // Clear existing content

    //     // Split the text into words by spaces
    //     const words = text.split(' ');

    //     words.forEach((word, index) => {
    //         // Loop through each character in the word
    //         for (let char of word) {
    //         const span = document.createElement('h2');
    //         span.classList.add('letter');
    //         span.textContent = char;
    //         h2Element.appendChild(span);
    //         }

    //         // Add a space between words if it's not the last word
    //         if (index < words.length - 1) {
    //         const spaceSpan = document.createElement('h2');
    //         spaceSpan.classList.add('letter');
    //         spaceSpan.textContent = ' ';
    //         h2Element.appendChild(spaceSpan);
    //         }
    //     });
    // });

});
$(window).on("resize", function(event){
    $('body').css({ '--custom-header-height': headerHeight + 'px' });
    $('body').css({ '--custom-footer-height': headerHeight + 'px' });
});